import React from 'react';
import { HealthDetailPage } from '@/components/shared/ReuseableHealthDeatil';
import { useGetMyBioAgeDetail } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { BiologicalAgeResponse } from '@viome/viome-base/src/usecase/Health/Health.model';
import { JourneyEducationTypes } from '@utils/JourneyEducationTypes';
import {
  getBioAgeAnimationFromLocal,
  getBioAgeOverlayImage,
} from '@/utils/health/getAnimation';
import { ErrorLoadingPage } from '@screens/ErrorHandling/ErrorLoadingPage';

export const BioAgePage: React.FC = () => {
  const { data, isError, isLoading } = useGetMyBioAgeDetail();

  if (isError) {
    return <ErrorLoadingPage variant="dark" />;
  }

  const {
    actual_age = 0,
    biological_age = 0,
    message = '',
    about = '',
  }: Partial<BiologicalAgeResponse> = data || {};

  return (
    <HealthDetailPage
      data={{
        title: 'Biological Age',
        about,
        mainStat: String(biological_age),
        subStat: message,
        additionalStat: `Actual Age ${String(actual_age)}`,
        size: 'lg',
        overlayImg: getBioAgeOverlayImage(biological_age, actual_age),
        videoSrc: getBioAgeAnimationFromLocal(biological_age, actual_age),
      }}
      isMainStatPercentage
      isLongvietySection
      journeyDeeperSectionInfo={JourneyEducationTypes.BIOAGE_DETAIL}
      isLoading={isLoading || !data}
      screen="bio_age_details"
    />
  );
};
